import { Divider, Text } from '@moda/om';
import React, { useMemo } from 'react';
import { MobileSiteNavOption } from '../../MobileSiteNavOption';

interface Props {
  label: string;
  url: string;
  isHighlighter: boolean;
  onClick: () => void;
}

export const RefreshedMobileSiteNavMenuLinkItem: React.FC<Props> = ({
  url,
  label,
  isHighlighter,
  onClick
}) => {
  const href = useMemo(() => {
    if (!url) return undefined;

    try {
      // we can log this -- here the url looks like https://modaoperandi.com/clothing/etc and it should be strict pathname
      return new URL(url).pathname;
    } catch (error) {
      return url;
    }
  }, [url]);

  return (
    <>
      <MobileSiteNavOption arrow={isHighlighter} href={href} onClick={onClick}>
        <Text treatment={isHighlighter ? 'bold1' : undefined}>{label}</Text>
      </MobileSiteNavOption>

      {isHighlighter && <Divider />}
    </>
  );
};
